// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"15143ca7","411":"646cae60","421":"c7f18677","544":"0c4d43bc","785":"f896c770"}[chunkId] + ".chunk.css";
};